import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { useApi } from '@fortem-monorepo/react-spa'
import { UploadTrack } from '@fortem-monorepo/web-sdk'

import { toastApiError } from '@/lib/error-toast'

export const useAddUploadTrackEntryMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: (body: UploadTrack.UploadPriceTrackFilesBody) => {
      return api.uploadTrack.uploadFiles(body)
    },
    onSuccess: () => {
      toast.success('Upload successful')
    },
  })
}

export const useUpdateInstrumentsMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: (body: UploadTrack.UpdateInstrumentsBody) => {
      return api.uploadTrack.updateInstrument(body)
    },
    onSuccess: (_data, params) => {
      toast.success(`Successfully updated ${params.oldValue} to ${params.newValue}`)
    },
    onError: (error, params) => {
      toastApiError(error, `Error updating ${params.oldValue} to ${params.newValue}`)
    },
  })
}
